export default __webpack_public_path__ + "static/media/Success.76937496.svg";